import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { useKeycloak } from "@react-keycloak/web";

import { dirname } from "../../util/resourcePath";
import { Link, useRouter } from "../../util/router";
import { logoutSession } from "../../util/authorization";
import { useSite } from "../../util/sites";

import NavbarSelect from "./NavbarSelect";
import NavbarUser from "./NavbarUser";

function Navbar() {
	const { keycloak, initialized } = useKeycloak();
	const router = useRouter();
	const currentSite = useSite();
	const directory = dirname();
	const location = useLocation();
	const exp = 'administration$';
	const hideSelect = location.pathname.match(exp);
	const [showUserNav, setShowUserNav] = useState(false);
	const userToken = keycloak.tokenParsed;
	useEffect(() => {
		const showUserNav = typeof userToken !== "undefined";

		setShowUserNav(showUserNav);
	}, [userToken]);

	return (
		<nav className="navbar navbar-inverse navbar">
			<div className="container90">
				<div className="navbar-header">
					<button
						type="button"
						className="navbar-toggle collapsed"
						data-toggle="collapse"
						data-target="#bs-example-navbar-collapse-1"
						aria-expanded="false"
					>
						<span className="sr-only">Toggle navigation</span>
						<span className="icon-bar"></span>
						<span className="icon-bar"></span>
						<span className="icon-bar"></span>
					</button>
					<Link className="navbar-brand " to="/solar/overview">
						<img src={`${directory}/images/greenyellow_logo.png`} alt="" />
					</Link>
				</div>
				<div
					className="collapse navbar-collapse"
					id="bs-example-navbar-collapse-1"
					style={{ overflowY: "visible" }}
				>
					{initialized && keycloak.authenticated && (
						<>
							{showUserNav && (
								<NavbarUser currentSite={currentSite.selectedSite} />
							)}
							<ul className="nav navbar-nav navbar-right">
								<li className="dropdown">
									<Link
										to=""
										className="dropdown-toggle dropdown-a"
										data-toggle="dropdown"
										aria-haspopup="true"
										aria-expanded="false"
									>
										<span
											className="glyphicon glyphicon-user"
											aria-hidden="true"
										></span>
										<span className="caret"></span>
									</Link>
									<ul className="dropdown-menu">
										<li>
											<span style={{ padding: "0 8px" }}>
												{keycloak.tokenParsed.name}
											</span>
										</li>
										<li>
											<Link
												to="#"
												onClick={(e) => {
													e.preventDefault();
													currentSite.clearSites();
													logoutSession(keycloak.tokenParsed.sub);
													keycloak.logout();
													router.push("/solar/logout");
												}}
											>
												LOGOUT
											</Link>
										</li>
									</ul>
								</li>
							</ul>
							{!hideSelect && <NavbarSelect />}
						</>
					)}
				</div>
			</div>
		</nav>
	);
}

export default Navbar;
